import {useDispatch, useSelector} from "react-redux";
import {getInvoices} from "../../../redux/action/accountActions";
import {condition} from "../../../res/rest/restRequest";
import {idempiereDate} from "../../../res/dataServices/idempiereDate";
import {invoiceService} from "../../../res/dataServices/invoiceService";
import {useState} from "react";

const useInvoices = () => {

    const forEachInvoiceLine = (ordering, forEach) => {
        if(ordering.invoices) {
            Object.values(ordering.invoices).forEach((invoice) => {
                const lines = invoice["web_ordering_invoiceLine_v"];
                if (lines) lines.forEach((line) => forEach(invoice, line));
            })
        }
    }

    const getInvoiceList = (ordering) => {
        if(!ordering.invoices) return [];
        const invoiceList = Object.values(ordering.invoices);
        invoiceList.sort((b,a) =>
            idempiereDate.compareDates(a.DateInvoiced, b.DateInvoiced)
        );
        return invoiceList;
    }

    const getLinks = (ordering) => {
        const links = {};
        forEachInvoiceLine(ordering, (invoice, line) => {
            const shipmentID = line["M_InOut_ID"];
            const orderID = line["C_Order_ID"];

            if(!links[invoice.id]) links[invoice.id] = {shipments: new Set(), orders: new Set()};
            const {shipments, orders} = links[invoice.id];

            if(shipmentID) shipments.add(shipmentID.id);
            if(orderID) orders.add(orderID.id)
        })
        return links;
    }

    const dispatch = useDispatch();

    const { session } = useSelector(
        state => state.auth
    )
    const { loading, error, ordering } = useSelector(
        state => state.account
    )
    const [fetchedDates, setFetchedDates] = useState({});

    const getInvoicesByDate = (startDate, endDate, limit) => {
        const conditions = [
            condition.greaterThan("created", startDate),
            condition.lessOrEqual("created", endDate)
        ]
        dispatch(getInvoices({session, conditions, limit}));
        setFetchedDates({startDate, endDate});
    }

    const getAnInvoice = (id) => {
        const conditions = [condition.eq("c_invoice_ID", id)];
        dispatch(getInvoices({session, conditions, includeProducts: true}));
    }

    const invoiceList = getInvoiceList(ordering);
    const status = invoiceService.paymentStatus;
    const invoiceByStatus = invoiceService.getInvoiceByStatus(invoiceList);
    const passedDueList = invoiceByStatus[status.PASSED_DUE];
    const unpaidList = invoiceByStatus[status.UNPAID];
    const paidList = invoiceByStatus[status.PAID];
    const links = getLinks(ordering);

    return {
        ordering,
        passedDueList,
        unpaidList,
        paidList,
        fetchedDates,
        links,
        loading,
        error,
        getInvoicesByDate,
        getAnInvoice
    }
}

export default useInvoices;